export default [
    'hasCarWash',
    'hasCarService',
    'hasTire',
    'hasInspectionPit',
    'hasVideoSurveillance',
    'hasHourSecurity',
    'hasAutomaticGates',
    'hasEntryByPass',
    'hasBasement'
];
